<template>
  <div class="order-address-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailAddressInfo.address" border style="width: 100%" v-loading="loading">
        <el-table-column prop="username" :label="$t('aOrderDetailAddress.userName')" align="center" width="150">
        </el-table-column>
        <el-table-column prop="tel" :label="$t('aOrderDetailAddress.phone')" align="center" width="150">
        </el-table-column>
        <el-table-column prop="address" :label="$t('aOrderDetailAddress.shippingAddress')" align="center"
          min-width="250">
        </el-table-column>
        <el-table-column prop="remark" :label="$t('aOrderDetailAddress.remark')" align="center" width="200">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderAddress } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailAddress',
  data() {
    return {
      aOrderDetailAddressInfo: {
        address: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailAddressInfo.orderId = params.orderId
      this.loadOrderAddressData()
    },
    loadOrderAddressData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailAddressInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderAddress(params).then(response => {
        this.aOrderDetailAddressInfo.address = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取订单地址失败:', error)
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderAddressData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderAddressData()
    }
  }
}
</script>

<style scoped>
.order-address-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>